(function () {
    'use strict';

    angular
        .module('surveyControllers')
        .controller('SurveyController', Controller);

    Controller.$inject = ['$scope', 'topBarService',];

    function Controller($scope, topBarService) {

        topBarService.setTitleAndIcon('Campaigns', 'fa fa-bullhorn');
    }
})();